import React from 'react';
import List from 'components/list/List';
import { Guide } from 'types/guide';
import ReportGuideItemModule from './ReportGuideItemModule';
import ReportGuideMenu from '../menu/ReportGuideMenu';
import { useReportGuide } from '../../hooks/useReportGuide';

interface ReportGuideListModuleProps {
  guides: Guide[];
}

const ReportGuideListModule: React.FC<ReportGuideListModuleProps> = ({ guides }) => {
  const { anchorEl } = useReportGuide();

  return (
    <>
      {anchorEl && <ReportGuideMenu anchorEl={anchorEl} />}
      <List>
        {guides.map(guide => (
          <ReportGuideItemModule key={guide.id} guide={guide} />
        ))}
      </List>
    </>
  );
};

export default ReportGuideListModule;
